import React, { useState } from 'react'
import {
  Box,
  Text,
  SimpleGrid,
  Button,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  VStack,
  Container,
  Image,
  Wrap,
  WrapItem
} from '@chakra-ui/react';

// import amazonLogo from '../../../images/death-book-tour/pre-order-partners/amazon.png'
// import powellLogo from '../../../images/death-book-tour/pre-order-partners/powells-book.png'
// import targetLogo from '../../../images/death-book-tour/pre-order-partners/target.png'
// import walmartLogo from '../../../images/death-book-tour/pre-order-partners/walmart.png'
// import hudsonLogo from '../../../images/death-book-tour/pre-order-partners/hudsonBooksellers.png'
// import bookshopLogo from '../../../images/death-book-tour/pre-order-partners/bookshop.png'
// import barnesLogo from '../../../images/death-book-tour/pre-order-partners/barnes-noble.png'
// import bamLogo from '../../../images/death-book-tour/pre-order-partners/bam.png'


const PreOrderPartners = ({ styleConfig, sectionContent }) => {

  // Central panel configuration
  const panels = [
    { key: sectionContent?.[2]?.data?.[0]?.key, label: sectionContent?.[2]?.data?.[0]?.type, partners: sectionContent?.[2]?.data?.[0]?.options },
    { key: sectionContent?.[2]?.data?.[1]?.key, label: sectionContent?.[2]?.data?.[1]?.type, partners: sectionContent?.[2]?.data?.[1]?.options },
    { key: sectionContent?.[2]?.data?.[2]?.key, label: sectionContent?.[2]?.data?.[2]?.type, partners: sectionContent?.[2]?.data?.[2]?.options },
  ]

  const [expandedPanel, setExpandedPanel] = useState('hardcover')

  const handlePanelChange = (panelKey) => {
    setExpandedPanel((prev) => (prev === panelKey ? null : panelKey));
  };

  const buttonSx = {
    fontSize: { xs: '18px', sm: '20', md: '22px' },
    fontWeight: { xs: 450, md: 500 },
    borderRadius: '10px',
    border: '2px solid #d4d4d4',
    backgroundColor: '#fff',
    textTransform: 'none',
    color: '#000',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    '&:hover': {
      border: '2px solid #d4d4d4',
      backgroundColor: '#9B6D18',
    },
  }

  return (
    <Box
      position={'relative'}
      id='pre-order'
    // sx={{
    //   position: 'relative',
    // }}
    >
      {/* {Background Image} */}

      {/* Title */}
      <Box
      bgImage={styleConfig?.bgImage?.url}
      pb={{ base:'2rem', md:'4rem'}}
      >
        <Box textAlign='center' mb={{ base: 4, md: 1 }}>
          <Text
            fontFamily={'JuanaAltRegular'}
            color='#007088'
            fontSize={
              {base: '36px', md: '50px'}
            }
            fontWeight='500' pt={{base:'3rem', md:'4rem', lg:'7rem'}}>
            {sectionContent?.[0]?.titleText}
          </Text>
          <Text
            fontSize={{ base: '20px', md: '24px' }}
            fontWeight={400}
            color='#000'
            mt={{base:'0.5rem', md: '0.5rem', lg: '1rem'}}
            mb={{base:'0rem', md:'1rem', lg: '3rem'}}
            fontFamily={"FedraSansStd-book"}
          >
            {sectionContent?.[1]?.text}
          </Text>
        </Box>

        {/* Accordions */}
        <SimpleGrid 
        ml={{base:'3%', md:"2%", lg:"8%", xl:'10%', '2xl': "15%"}}
         columns={{ base: 1, md: 1, lg: 2 }} spacing={4}>
          <Box display={'flex'} flexDirection={'column'} ml={'auto'} mt={{base:'3rem', lg:'4rem', 'xl': '3rem'}}>
            {panels.map(({ key, label, partners }) => (
              <Accordion
                allowToggle
                key={key}
                index={expandedPanel === key ? 0 : -1}
                onChange={() => handlePanelChange(key)}
                border="2px solid #e6e6e7"
                borderRadius="8px"
                overflow="hidden"
                mb={4}
                width={{base: '97%', md:'98%', lg: "500px", xl:'600px', '2xl':'751px'}}
              >
                <AccordionItem border="none">
                  {({ isExpanded }) => (
                    <>
                      <AccordionButton
                        bg="#f9f9f9"
                        px={4}
                        py={2}
                        _hover={{ bg: '#f0f0f0' }}
                      >
                        <Box flex="1" textAlign="left">
                          <Text
                            fontSize={{ base: '22px', md: '26px' }}
                            fontWeight={600}
                            color="#9B6D18"
                            fontFamily={"FedraSansStd-book"}
                          >
                            {label}
                          </Text>
                        </Box>
                        {/* Optional: Add/remove icons */}
                        {/* <AccordionIcon color="#9B6D18" /> */}
                        {isExpanded ? <svg width="13" height="5" viewBox="0 0 13 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0.52 4.28V0.799999H12.44V4.28H0.52Z" fill="#9B6D18" />
                        </svg> : <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.49345 14.572V8.664H0.613453V6.34L6.49345 6.396V0.348H8.87345L8.78945 6.424L14.9775 6.34V8.664H8.84545L8.87345 14.572H6.49345Z" fill="#9B6D18" />
                        </svg>}
                      </AccordionButton>

                      <AccordionPanel bg={'#FFFFFF'} px={4}>
                        <Text
                          fontSize={{ base: '20px', md: '24px' }}
                          fontWeight={500}
                          color="#0C0C0C"
                          mt={2} mb={6}
                          fontFamily={"FedraSansStd-book"}                          
                        >
                          {sectionContent?.[2]?.data?.[0]?.title}
                        </Text>
                        <Wrap spacing={3} mb={2}>
                          {partners.map((partner, idx) => (
                            <WrapItem key={idx}>
                              <Button
                                as="a"
                                href={partner.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                variant="outline"
                                justifyContent="center"
                                borderColor="#0000002B"
                                color="#000000"
                                _hover={{ bg: "#f3e9d6" }}
                                fontWeight="450"
                                width="fit-content"
                                fontSize={{base:'20px', md: "24px" }}
                              >
                                {partner.name}
                              </Button>
                            </WrapItem>
                          ))}
                        </Wrap>
                      </AccordionPanel>
                    </>
                  )}
                </AccordionItem>
              </Accordion>
            ))}
          </Box>

          <Box
            order={{ base: -1, md: -1, lg: 2 }}
            display="flex"
            justifyContent={{base:'center', md: "center", lg: 'flex-start'}}
            // alignItems="center"
          >
              <Image 
              width={{base:'180px', md:'380px'}}
              header={{base:'308px', md:'651px'}} src={sectionContent?.[3]?.image?.url} alt="Book cover" />
          </Box>
        </SimpleGrid>
      </Box>
    </Box>
  )
}


export default PreOrderPartners;
